<template>
  <div>
    <div class="setting-colr rounded mb-1" @click="show = !show">
      <p class="mb-0">โลโก้</p>

      <i class="fas fa-plus-circle" />
    </div>

    <div v-if="show" class="clrr-setting">
      <div class="input-file-container">
        <i class="fal fa-plus cursor-pointer" />
        <label for="img-file" class="input-file-label">{{
          logo ? "เปลี่ยนรูปภาพ" : "เพิ่มรูปภาพ"
        }}</label>
        <input
          id="img-file"
          type="file"
          class="input-file"
          accept="image/*"
          @change="handleFileChange"
        />
      </div>

      <div v-if="logo" class="image-preview">
        <img :src="logo" alt="Preview" class="preview-image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['logo'],
  data: () => ({
    show: false,
    agent: null
  }),
  mounted() {
  },
  methods: {
    async handleFileChange(event) {
      const base64 = await this.getBase64Image(event.target.files[0]);
      this.$emit('setData', base64);
    },
    getBase64Image(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          resolve(event.target.result);
        };
        reader.onerror = (error) => {
          reject(error);
        };
        reader.readAsDataURL(file);
      });
    },
  },
};
</script>
